import React from 'react';
import { Target, Cake, Package } from 'lucide-react';
import PageBanner from '../layout/PageBanner';
import SectionHeading from '../ui/SectionHeading';
import { aboutText } from '../../data/company';

const AboutPage = () => {
  return (
    <div>
      <PageBanner
        title="ABOUT US"
        breadcrumbs={[{ label: 'ABOUT US' }]}
      />

      {/* Our History Section */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="/images/gallery/dessert-plate-1.jpeg"
                alt="Mirage Desserts"
                className="rounded-lg shadow-lg"
              />
            </div>
            <div>
              <SectionHeading title="OUR HISTORY" centered={false} />
              <div className="space-y-4 text-gray-600">
                {aboutText.history.map((paragraph, index) => (
                  <p key={index} className="leading-relaxed">{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Welcome Section with Mission/Vision/Products */}
      <section className="py-16 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <SectionHeading title="Welcome to Mirage Desserts" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                <Target size={40} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-3">Our Mission</h3>
              <p className="text-gray-600">{aboutText.mission}</p>
            </div>
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                <Cake size={40} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-3">Our Vision</h3>
              <p className="text-gray-600">{aboutText.vision}</p>
            </div>
            <div className="text-center p-6">
              <div className="w-20 h-20 bg-primary-red rounded-full flex items-center justify-center mx-auto mb-4">
                <Package size={40} className="text-white" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-3">Our Products</h3>
              <p className="text-gray-600">{aboutText.products}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-16 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <blockquote className="text-2xl font-serif italic text-gray-700">
            "{aboutText.testimonial}"
          </blockquote>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
